import { logger, ROUTES } from '@sd/shared';
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { v4 } from 'uuid';
import { Link } from 'react-router-dom';
import { DocumentTitle } from '../DocumentTitle/DocumentTitle';
import pageNotFoundPng from './pageNotFound.png';

export const NotFoundScene = () => {
  const errorId = useMemo(() => v4().split('-').slice(-1)[0], []);

  useEffect(() => {
    logger.warn('app:notFound', { errorId });
  }, []);

  return (
    <div data-testid="not-found-scene" className="text-align-middle">
      <DocumentTitle title="Page Not Found" />
      <Header>Oops this page may have swerved off course</Header>
      <ErrorCode>Error Code Reference: {errorId}</ErrorCode>
      <SwerveImg src={pageNotFoundPng} alt="Swerve."></SwerveImg>
      <ButtonsContainer>
        <Button className="m-1" href={ROUTES.external.legacySellerDashboard.sales.externalUrlFor()}>
          Get Back on the Road
        </Button>
        <Button as={Link} className="m-1" to={ROUTES.appShell.logout.locationFor()}>
          Escape To Login
        </Button>
      </ButtonsContainer>
    </div>
  );
};

const SwerveImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5em;
`;
const Header = styled.h1`
  text-align: center;
  text-transform: none;
`;
const ErrorCode = styled.h5`
  text-align: center;
  text-transform: none;
`;
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
`;
